import React from 'react'
import Logo from '../media/logo.jpg'
import { Facebook, Twitter, Instagram } from "lucide-react"
import { FaWhatsapp } from "react-icons/fa";


export default function Footer(){
return (
<footer className="mt-12 bg-white border-t">
<div className="max-w-6xl mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-4 gap-6">
<div className="col-span-1">
    <div className="text-5xl font-bold text-black flex items-center ">
            <a className="flex items-center" href="/">
                <img src={Logo} alt="yking-logo" className="h-20" />
                <span className="">YKING</span>
            </a>
            </div>
    <div className="flex gap-3 justify-center ">
        <div className="flex space-x-4">
            {/* <a
              href="https://facebook.com/YKing"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 bg-orange-500 hover:bg-orange-600 rounded-full text-white transition"
            >
              <Facebook className="w-5 h-5" />
            </a>
            <a
              href="https://twitter.com/YKing"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 bg-orange-500 hover:bg-orange-600 rounded-full text-white transition"
            >
              <Twitter className="w-5 h-5" />
            </a>
            <a
              href="https://instagram.com/YKing"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 bg-orange-500 hover:bg-orange-600 rounded-full text-white transition"
            >
              <Instagram className="w-5 h-5" />
            </a> */}
            <a
              href="https://wa.me/923000808255"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 bg-orange-500 hover:bg-orange-600 rounded-full text-white transition"
            >
              <FaWhatsapp className="w-5 h-5" />
            </a>
          </div>
    </div>
</div>


<div className="col-span-2 md:col-span-3 grid grid-cols-3 gap-4 text-sm text-gray-600">
<div>
<ul>
<li className="py-1"><a href="/">Home</a></li>
<li className="py-1"><a href="/our-story">Our Story</a></li>
<li className="py-1"><a href="/culture">Culture</a></li>
<li className="py-1"><a href="/our-philosophy">Our Philosophy</a></li>
<li className="py-1"><a href="/sustainability-ethics-compliance">Sustainability, Ethics & Compliance</a></li>
<li className="py-1"><a href="/digitalisation">Digitalisation</a></li>
</ul>
</div>
<div>
<ul>
<li className="py-1"><a href="/menswear">Menswear</a></li>
<li className="py-1"><a href="/womenswear">Womenswear</a></li>
<li className="py-1"><a href="/kidswear">Kidswear</a></li>
<li className="py-1"><a href="/promotional-wear">Promotional Wear</a></li>
<li className="py-1"><a href="/workwear">Workwear</a></li>
</ul>
</div>
<div>
<ul>
<li className="py-1"><a href="/uniform">Uniform</a></li>
<li className="py-1"><a href="/sportswear">Sportswear</a></li>
<li className="py-1"><a href="/home-textile">Home Textile</a></li>
<li className="py-1"><a href="/shoes">Shoes</a></li>
<li className="py-1"><a href="/contact-us">Contact Us</a></li>
</ul>
</div>
</div>
</div>
<div className="bg-gray-700 h-12 flex justify-left items-center" ><h1 className='m-10 text-white'>2025 © Yking</h1></div>
</footer>
)
}